export default __webpack_public_path__ + "static/media/Gotham-Bold.e7e90266.ttf";